export default {
      id: "ar_seniors-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ar_seniors-usage",
      toString: function () {
        return this.url;
      }
    }